<template>
    <div>
      <Head title="Traffic" />
      <h1 class="mb-8 text-3xl font-bold">Funnel traffic</h1>
      <div class="flex items-center justify-between mb-6">
        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" :inputIsVisible="false">

          <label class="block text-gray-700">Utm source:</label>
          <select v-model="utm_source" class="form-select mt-1 w-full">
            <option :value="value.id" v-for="value in utm_sources" :key="value.id">{{ value.name }}</option>
          </select>
          <label class="block text-gray-700">Utm campaign:</label>
          <select v-model="form.utm_campaign" class="form-select mt-1 w-full">
              <option :value="null">All campaign</option>
            <option :value="value" v-for="value in utm_campaign" :key="value">{{ value }}</option>
          </select>
          <label class="block text-gray-700">Utm medium:</label>
          <select v-model="form.utm_medium" class="form-select mt-1 w-full">
            <option :value="null">All medium</option>
            <option :value="value" v-for="value in utm_medium" :key="value">{{ value }}</option>
          </select>
        </search-filter>
      </div>
      
      <div class="bg-white rounded-md shadow ">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
            <th class="px-6 py-4">Funnel step</th>
            <th class="px-6 py-4">Percentage of total visitors</th>
            <th class="px-6 py-4">Visitor count</th>
        </tr>
        <tr class="hover:bg-gray-100 focus-within:bg-gray-100" v-for="row in traffic.map" :key="'traffic'+row.target">
            <td class="px-6 py-4 border-t">Step {{ row.target }}</td>
            <td class="px-6 py-4 border-t" >
                <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
                    <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center text-white py-2 p-0.5 leading-none rounded-full" :style="{
                            width: row.percentage+'%'
                        }"> 
                        {{ row.percentage }} %
                    </div>
                </div>
            </td>
            <td class="px-6 py-4 border-t">
                {{ row.visitors }}
            </td>
        </tr>
        <tr v-if="traffic.length === 0">
          <td class="px-6 py-4 border-t" colspan="3">No traffic found.</td>
        </tr>
      </table>
    </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchInput from '@/Shared/SearchInput'
  import SearchFilter from "@/Shared/SearchFilter";
  
  export default {
    components: {
        SearchFilter,
      Head,
      Icon,
      Link,
      SearchInput,
    },
    layout: Layout,
    props: {
        filters: Object,
        traffic: Array,
        trafficSource: String,
        utm_medium: Array,
        utm_campaign: Array,
        utm_sources: Array
    },
    data() {
      return {
        utm_source: this.trafficSource,
        form: {
          utm_medium: this.filters.utm_medium,
          utm_campaign: this.filters.utm_campaign
        },
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get(`/traffic/${this.trafficSource}`, pickBy(this.form), { preserveState: true })
        }, 150),
      },
      utm_source: {
        deep: true,
        handler: throttle(function (value) {
          this.$inertia.get(`/traffic/${value}`, {}, { preserveState: true })
        }, 150),
      }
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
  </script>
  